<template>
	<div class="bb-panel-wrapper">
		<span class="b360-form-label" role="heading">Select an image</span>
		<section class="image-column">
			<BBImageCard
				v-for="(card, index) in selectedVariationMedias"
				:key="index"
				:card="card"
				@selected="selectCard(card)"
				:radioKey="index"
				:selected="card.mediaId === selectedImage.mediaId"
			/>
		</section>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BBImageCard from '@/components/brand-builder/bb-design/BBImageCard.vue';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'BbImages',
	components: {
		BBImageCard,
	},
	computed: {
		...mapGetters(['selectedVariationMedias']),
		...mapState({
			selectedImage: (state) => state.brandBuilderEditor.selectedImage,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
		}),
	},
	methods: {
		...mapActions(['selectImage']),
		selectCard(card) {
			this.selectImage(card);
		},
		nextStep() {
			if (
				this.selectedMediaType === MEDIA_ID.FLYER ||
				this.selectedMediaType === MEDIA_ID.SOCIAL_MEDIA ||
				this.selectedMediaType === MEDIA_ID.EMAIL
			) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/colors`,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.image-column {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;

	@include sm {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 15px;
	}

	@include phablet {
		grid-template-columns: repeat(2, 1fr);
	}

	@include mobile {
		grid-template-columns: 1fr;
	}
}
</style>
